<template>
    <div>
        <svg class="w-4 h-4" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.34437 17.1985C12.9528 17.1985 16.6887 13.4626 16.6887 8.85414C16.6887 4.24567 12.9528 0.509766 8.34437 0.509766C3.7359 0.509766 0 4.24567 0 8.85414C0 13.4626 3.7359 17.1985 8.34437 17.1985Z" fill="#2C4460"/>
            <path v-if="active" fill-rule="evenodd" clip-rule="evenodd" d="M8.34361 12.1921C10.187 12.1921 11.6814 10.6977 11.6814 8.85435C11.6814 7.01096 10.187 5.5166 8.34361 5.5166C6.50022 5.5166 5.00586 7.01096 5.00586 8.85435C5.00586 10.6977 6.50022 12.1921 8.34361 12.1921Z" fill="white"/>
        </svg>
    </div>
</template>
<script>
export default {
    name: "IconRadio",
    props: {
        active: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style scoped>

</style>